import { BdArrayUtil } from '@bindoc-projects/util-domain-lib';
import type {
  FilterConditionPluginSpecification,
} from '../filter.plugin';
import {
  FilterConditionPluginImpl
} from '../filter.plugin';
import type {
  BdCondition,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdContentCondition,
} from '@bindoc-projects/condition-domain-lib';
import type { AtVirtualClinicDismissalType } from '@bindoc-projects/virtual-clinic-domain-lib';

export const AT_DISMISSAL_TYPE_CONDITION_ID = 'dismissalTypeAT';
export const AtFilterConditionDismissalTypePluginType: FilterConditionPluginSpecification<
  AtVirtualClinicDismissalType[],
  AtFilterConditionDismissalTypeDto,
  AtDismissalTypeCondition
> = {
  type: 'dismissalType',
  category: 'case',
  displayName: { de: 'Entlassart' },
  sortingIndex: 9,
  occurrence: 'single',
  fromObject(
    obj: AtFilterConditionDismissalTypeDto,
  ): FilterConditionPluginImpl<AtVirtualClinicDismissalType[]> {
    return new AtFilterConditionDismissalTypePlugin(obj.dismissalType);
  },
  fromCondition(
    jsonObj: AtDismissalTypeCondition,
  ): FilterConditionPluginImpl<AtVirtualClinicDismissalType[]> {
    return new AtFilterConditionDismissalTypePlugin(jsonObj.includes ?? []);
  },
  newInstance(): FilterConditionPluginImpl<AtVirtualClinicDismissalType[]> {
    return new AtFilterConditionDismissalTypePlugin([]);
  },
};

export class AtFilterConditionDismissalTypePlugin extends FilterConditionPluginImpl<
  AtVirtualClinicDismissalType[],
  AtFilterConditionDismissalTypeDto
> {
  static override Specification: FilterConditionPluginSpecification<
    AtVirtualClinicDismissalType[],
    AtFilterConditionDismissalTypeDto,
    AtDismissalTypeCondition
  > = AtFilterConditionDismissalTypePluginType;

  constructor(protected dismissalType: AtVirtualClinicDismissalType[]) {
    super(AtFilterConditionDismissalTypePluginType.type);
  }

  clone(): AtFilterConditionDismissalTypePlugin {
    return new AtFilterConditionDismissalTypePlugin([...this.dismissalType]);
  }

  override equals(other: AtFilterConditionDismissalTypePlugin): boolean {
    return (
      super.equals(other) &&
      BdArrayUtil.equals(this.dismissalType, other.dismissalType)
    );
  }

  override validationToText(): string {
    if (this.dismissalType.length === 0) {
      return 'Mindestens eine Entlassart auswählen';
    } else {
      return '';
    }
  }

  toCondition(): BdCondition | null {
    return new AtDismissalTypeCondition(this.dismissalType, []);
  }

  toText(): string | null {
    return this.dismissalType.length === 2
      ? 'eine Entlassart'
      : `${this.dismissalType.length} Entlassarten`;
  }

  toJSON(): AtFilterConditionDismissalTypeDto | null {
    return {
      type: this.type,
      dismissalType: this.dismissalType,
    };
  }

  toValue(): AtVirtualClinicDismissalType[] {
    return this.dismissalType;
  }
}

export class AtDismissalTypeCondition extends BdContentCondition<AtVirtualClinicDismissalType> {
  constructor(
    includes: AtVirtualClinicDismissalType[],
    excludes: AtVirtualClinicDismissalType[],
  ) {
    super(AT_DISMISSAL_TYPE_CONDITION_ID, includes, excludes);
  }
}

interface AtFilterConditionDismissalTypeDto {
  type: string;
  dismissalType: AtVirtualClinicDismissalType[];
}
